module.exports = __webpack_public_path__ + "img/ru.6386b830.svg";